import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "badge-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["badge", {brand: $props.brand, gray: $props.gray, indigo: $props.indigo, success: $props.success, error: $props.error, blue: $props.blue, color: $props.color, border: $props.border, small: $props.small, rounded: $props.rounded, icon: $props.icon, uppercase: $props.uppercase}])
  }, [
    (!!$props.icon)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          size: "1.6rem",
          icon: $props.icon,
          class: "icon"
        }, null, 8 /* PROPS */, ["icon"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_Collapse, {
      open: $props.open,
      horizontal: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["open"])
  ], 2 /* CLASS */))
}